"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactAnimateHeight = _interopRequireDefault(require("react-animate-height"));
var _useTrigger2 = _interopRequireDefault(require("../../hooks/useTrigger"));
var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * The Expander component display (or hide) information with expand/collapse animation.
 */
var Expander = function Expander(props) {
  var _initialTrigger$props;
  var initialTrigger = props.trigger,
    initialIsOpen = props.isOpen,
    iconPosition = props.iconPosition,
    onClick = props.onClick,
    countId = props.countId,
    className = props.className,
    children = props.children,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    Tag = props.tag;
  var isInitialMount = (0, _react.useRef)(true);
  var _useState = (0, _react.useState)(initialIsOpen ? 'auto' : 0),
    height = _useState[0],
    setHeight = _useState[1];
  var _useState2 = (0, _react.useState)(initialIsOpen || false),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var idCount = (0, _react.useRef)((0, _useRandomId.default)(countId)).current;
  var toggleExpander = function toggleExpander(event) {
    event.stopPropagation();
    if (onClick && typeof onClick === 'function') {
      onClick(event);
    }
    setIsOpen(!isOpen);
    setHeight(height === 0 ? 'auto' : 0);
  };
  var toggleExpanderOnKeyPress = function toggleExpanderOnKeyPress(event) {
    var keyCode = event.nativeEvent.keyCode;
    if (keyCode === 13 || keyCode === 32) {
      onClick(event);
    }
  };
  var id = initialTrigger == null || (_initialTrigger$props = initialTrigger.props) == null ? void 0 : _initialTrigger$props.id;
  var _useTrigger = (0, _useTrigger2.default)(initialTrigger, {
      'aria-expanded': height !== 0,
      'aria-controls': "controlId" + (id || idCount),
      'aria-disabled': disabled,
      role: Tag === 'button' ? null : 'button',
      id: "expanderId" + (id || idCount),
      onClick: toggleExpander,
      onKeyPress: toggleExpanderOnKeyPress,
      className: (0, _clsx.default)('uk-expander__head', /*#__PURE__*/_react.default.isValidElement(initialTrigger) && initialTrigger.props && initialTrigger.props.className)
    }, 'div'),
    trigger = _useTrigger.trigger;
  (0, _react.useEffect)(function () {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      setIsOpen(initialIsOpen);
      setHeight(initialIsOpen ? 'auto' : 0);
    }
  }, [initialIsOpen]);
  var classes = (0, _clsx.default)('uk-expander', iconPosition !== 'hide' && iconPosition, isOpen && 'open', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, trigger, children && /*#__PURE__*/_react.default.createElement(_reactAnimateHeight.default, {
    className: "uk-expander__panel",
    duration: 240,
    height: height,
    id: "controlId" + (id || idCount),
    role: "region",
    "aria-labelledby": "expanderId" + (id || idCount)
  }, children));
};
Expander.propTypes = {
  /**
   * Show or hide the Expander (controlled)
   */
  isOpen: _propTypes.default.bool,
  /**
   * Expander's trigger
   */
  trigger: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  /**
   * Alignment of the +/- within the Expander
   */
  iconPosition: _propTypes.default.oneOf(['left', 'right', 'hide']),
  /**
   * Callback function onClick
   */
  onClick: _propTypes.default.func,
  /**
   * Legacy: will be deprecated in v.1.0.0
   */
  handleClick: _propTypes.default.func,
  /**
   * Internal prop used by the Accordion
   */
  expander: _propTypes.default.bool,
  /**
   * HTML tag used as root tag of the Expanders trigger
   */
  tag: _propTypes.default.string
};
Expander.defaultProps = {
  isOpen: false,
  iconPosition: 'left',
  expander: true,
  tag: 'button'
};
var _default = exports.default = Expander;